import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const profileData = {
    name: "Edrian Bass",
    tagline: "IT Engineer • Entrepreneur • Mentor • Creative Director",
    image: "/assets/images/WhatsApp_Image_2026-01-14_at_10.10.46_AM-1768414282695.jpeg",
    imageAlt: "Edrian Bass - Professional IT Engineer and Entrepreneur",
    stats: [
    { icon: "Code2", value: "8+", label: "Years Experience" },
    { icon: "Users", value: "150+", label: "Clients Served" },
    { icon: "Award", value: "25+", label: "Projects Completed" },
    { icon: "Briefcase", value: "5+", label: "Businesses Founded" }]

  };

  return (
    <section className="relative min-h-[600px] lg:min-h-[700px] flex items-center py-16 lg:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-secondary/5 to-background" />
      <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="order-2 lg:order-1">

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">

              <Icon name="Sparkles" size={18} color="var(--color-primary)" />
              <span className="text-sm font-medium text-primary">About Me</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6">

              {profileData?.name}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="text-lg md:text-xl text-muted-foreground mb-8 lg:mb-12">

              {profileData?.tagline}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">

              {profileData?.stats?.map((stat, index) =>
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.6 + index * 0.1, duration: 0.4 }}
                className="text-center">

                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-2 md:mb-3">
                    <Icon name={stat?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <div className="text-2xl md:text-3xl font-bold mb-1">{stat?.value}</div>
                  <div className="text-xs md:text-sm text-muted-foreground">{stat?.label}</div>
                </motion.div>
              )}
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="order-1 lg:order-2">

            <div className="relative">
              <motion.div
                animate={{
                  rotate: [0, 5, 0, -5, 0],
                  scale: [1, 1.02, 1, 1.02, 1]
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="relative z-10">

                <div className="aspect-[3/4] rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl">
                  <Image
                    src={profileData?.image}
                    alt={profileData?.imageAlt}
                    className="w-full h-full object-cover" />

                </div>
              </motion.div>

              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.3, 0.5, 0.3]
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="absolute -inset-4 bg-gradient-to-br from-primary/30 to-secondary/30 rounded-2xl lg:rounded-3xl blur-2xl" />

            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );


};

export default HeroSection;